import { useEditNoteDrawerContext } from '~/lib/contexts/EditNoteDrawerContext';
import {
  ChakraButton,
  ChakraFlex,
  DateFormat,
  FAIconName,
  Icon,
  Text,
} from '@equip.health/ui';
import { DateTime } from 'luxon';
import { useEditPatientNoteFormContext } from '~/lib/contexts/EditPatientNoteFormContext';
import { useFormikContext } from 'formik';
import { EditNoteFormData } from '~/lib/types/notes/EditNoteFormData';
import { useAnalytics } from '~/lib/contexts/AnalyticsContext';
import { PatientEvents } from '~/analytics/patientEvents';

export const EditNoteDrawerMinimizedButton = () => {
  const { drawerStatus, unminimize } = useEditNoteDrawerContext();
  const { trackEvent } = useAnalytics();
  const {
    note,
    closeNoteDrawerWithoutSaving,
    isUpdateNoteLoading,
    isAutosaveNoteLoading,
  } = useEditPatientNoteFormContext();
  const { values: formValues } = useFormikContext<EditNoteFormData>();

  if (drawerStatus !== 'minimized' || !note || !formValues) {
    return <></>;
  }

  return (
    <ChakraFlex
      alignItems="center"
      backgroundColor="white"
      borderRadius="12px"
      bottom="60px"
      boxShadow="0px 0px 8px 0px rgba(0, 0, 0, 0.16)"
      gap="12px"
      padding="18px"
      position="absolute"
      right="24px"
      zIndex={101}
    >
      <Icon color="accent.blue" name={FAIconName.fileLinesRegular} size="lg" />
      <ChakraFlex direction="column">
        <Text variant="bodyMedium">{formValues.title}</Text>
        <Text color="neutral.secondary" variant="caption">
          {`Created ${DateTime.fromISO(note.createdDateTime, { zone: 'UTC' })
            .toLocal()
            .toFormat(DateFormat.longDateWithTime)}`}
        </Text>
      </ChakraFlex>
      <ChakraFlex>
        <ChakraButton
          aria-label="Expand note"
          height="32px"
          isDisabled={isUpdateNoteLoading || isAutosaveNoteLoading}
          minWidth="28px"
          onClick={() => {
            trackEvent(PatientEvents.expandSessionGuideDrawer);
            unminimize();
          }}
          paddingX="2px"
          variant="ghost"
        >
          <Icon color="neutral.primary" name={FAIconName.arrowUpLeft} />
        </ChakraButton>
        <ChakraButton
          aria-label="Close note"
          height="32px"
          isDisabled={isUpdateNoteLoading || isAutosaveNoteLoading}
          minWidth="28px"
          onClick={closeNoteDrawerWithoutSaving}
          paddingX="2px"
          variant="ghost"
        >
          <Icon color="neutral.primary" name={FAIconName.xmarkLight} />
        </ChakraButton>
      </ChakraFlex>
    </ChakraFlex>
  );
};
